import React from "react";
import "./TermsAndConditionsPage.scss";
import { Page } from "components/core/Page";
import {
	HeadingPoints,
	SmallSearchBar,
	TERMS_AND_CONDITIONS_DATA
} from "components/sdc/TermsAndConditions";
import Container from "components/core/Page/Container";
import { ScrollToTop } from "components/core/ScrollToTop";
import { Heading } from "components/storages/Common";
import { useSelector } from "react-redux";

function TermsAndConditionsPage() {
	const baseUrl = useSelector((state) => state?.app?.baseUrl);
	return (
		<Page
			title="Terms and Conditions, Storage Units, Mini Storage, Business Storage at Storage.com"
			description=""
			canonical={`${baseUrl}/about-us/terms-and-conditions/`}
		>
			<Container>
				<div className="sdc-page-container">
					<div className="first-col">
						<Heading
							content="Storage.com"
							level="1"
							size="xlarge"
						/>
						<Heading
							content="Effective for all Users as of October, 22, 2025"
							level="2"
							size="large"
							weight="regular"
						/>
						{TERMS_AND_CONDITIONS_DATA.map((item) => (
							<>
								<HeadingPoints {...item} />
							</>
						))}
					</div>
					<div className="second-col">
						<SmallSearchBar />
					</div>
				</div>
			</Container>
			<ScrollToTop />
		</Page>
	);
}

export default TermsAndConditionsPage;
